// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZyFSp","top":"styles_top__1uegm","left":"styles_left__1G7Nd","description":"styles_description__34dlS"};